import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import * as React from "react";
import {useTheme} from "@mui/material";

const styles = (
    theme: any,
) => ({
    sx: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: theme.palette.primary.main
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.input.focus,
            },
            "&.Mui-disabled": {
                "& fieldset": {
                    borderColor: `${theme.palette.primary.main} !important`,
                },
                "& input": {
                    color: `${theme.palette.primary.contrastText} !important`,
                    WebkitTextFillColor: `${theme.palette.primary.contrastText} !important`,
                },
                "& .MuiSvgIcon-root": {
                    display: "none !important"
                },
            },
        },
        "& .MuiInputBase-input": {
            color: theme.palette.primary.contrastText,
        },
        "& .Mui-focused": {
            color: theme.palette.input.focus,
        },
        "& .MuiSvgIcon-root": {
            color: theme.palette.input.focus
        },
        "& .MuiInputLabel-root.Mui-disabled": {
            color: `${theme.palette.primary.main} !important`,
        },
    }
})

interface AutoCompleteSelectProps {
    options: string[];
    value: string | null;
    handleSelection: (
        event: React.SyntheticEvent<Element, Event>,
        value: string | null
    ) => void;
    disabled: boolean;
    textLabel: string;
    allowTyping: boolean;
}

export default function AutoCompleteSelect(
    {
        options,
        handleSelection,
        value,
        disabled,
        allowTyping,
        textLabel,
    }: AutoCompleteSelectProps
) {
    const theme = useTheme();

    return (
        <Autocomplete
            className="rounded-full"
            disablePortal
            id="combo-box-demo"
            options={options}
            sx={() => styles(theme).sx}
            value={value}
            onChange={handleSelection}
            freeSolo={allowTyping}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={textLabel}
                    InputProps={{
                        ...params.InputProps,
                        readOnly: !allowTyping,
                        style: { color: "black" },
                    }}
                />
            )}
            renderOption={(props, option, state) => (
                <li
                    {...props}
                    style={{
                        backgroundColor: state.selected ? theme.palette.grey[300] : "transparent",
                        color: "black",
                    }}
                >
                    {option}
                </li>
            )}
        />
    )
}
